module.exports = __webpack_public_path__ + "dcf8618502c27f956d2649e39acd5762.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-1.png
// module id = 3023
// module chunks = 0